import { render, staticRenderFns } from "./DialogFormManufacturerEdit.vue?vue&type=template&id=018a8740"
import script from "./DialogFormManufacturerEdit.vue?vue&type=script&lang=js"
export * from "./DialogFormManufacturerEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports